export default {
  select_size: 'Wybierz rozmiar',
  required: 'Wymagane',
  required_missing: 'Wymagane — dokonaj wyboru',
  optional: 'Opcjonalne',
  select_up_to: 'Wybierz do {{maxCount}}',
};
